module.exports = __webpack_public_path__ + "static/img/WZWP.364276f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/logo/WZWP.png
// module id = 4CGD
// module chunks = 1